import React from "react";
import "./style.css";

export const ElementIcTik = ({ className }) => {
  return <div className={`element-ic-tik ${className}`} />;
};
